import * as React from 'react';

import { getTypographyClassName, TypographyVariant } from '@ui/components/base/typography';
import { cn } from '@ui/lib/utils';

enum LabelVariant {
  DEFAULT = 'default',
  OVERLINE = 'overline',
  MUTED = 'muted',
}

const LABEL_VARIANT_CLASSNAMES: Record<LabelVariant, string> = {
  [LabelVariant.DEFAULT]: '',
  [LabelVariant.OVERLINE]: getTypographyClassName({ variant: TypographyVariant.OVERLINE }),
  [LabelVariant.MUTED]: getTypographyClassName({ variant: TypographyVariant.MUTED }),
};

interface LabelProps extends React.ComponentProps<'label'> {
  variant?: LabelVariant;
}

const Label = ({ className, variant = LabelVariant.DEFAULT, ...props }: LabelProps) => {
  return (
    <label
      data-slot="label"
      className={cn(
        'flex items-center gap-2 text-sm leading-none font-medium select-none',
        'group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50',
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        LABEL_VARIANT_CLASSNAMES[variant],
        className
      )}
      {...props}
    />
  );
};

export { Label, LabelVariant };
